exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".MobileUserAccount__editProfileBtn___1F7NVTkr {\n  margin: 0;\n}\n", ""]);
// Exports
exports.locals = {
	"editProfileBtn": "MobileUserAccount__editProfileBtn___1F7NVTkr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/mobile/components/MobileUserAccount.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = 9W0Z
// module chunks = 3